<span class="orms-health-icon" [ngClass]="iconColor"></span>
